import {TPaginationType} from 'plugins/modules/pagination/types';

export const makeListingLoadingId = (action: string, type: TPaginationType) => {
    return `${action}__pag:${type}`;
};
